export default __webpack_public_path__ + "static/media/Gloves of Concealing Shadows.1065cdec.jpg";